import { NavPreferenceUtil } from './_utils/nav-preference.util';

function makeAppConfig() {
    const date = new Date();
    const year = date.getFullYear();

    // EAS-249: restaura a preferência de menu recolhido/expandido do usuário.
    // Default no primeiro acesso (sem preferência salva): aberto (false).
    const storedNavCollapsed = NavPreferenceUtil.load();

    let porta = '';
    let apiHostname = window.location.hostname;
    let easyWebPage = 'http://localhost:4200';
    let easyWeb2Page = 'http://localhost:4200';
    let finServer = 'integracao.portalpostal.com.br';
    let finContext = '/';

    if (window.location.hostname === 'adm.test.easymarine.com.br') {
        apiHostname = 'test.api.easymarine.com.br';
        porta = '';
        easyWebPage = 'http://test.site.easymarine.com.br';
        easyWeb2Page = 'http://test.site.easymarine.com.br';
        finServer = 'test.fin.easymarine.com.br';
    }

    if (window.location.hostname === 'localhost') {
        finServer = 'localhost:8083';
        porta = ':8080';
    }

    if (window.location.host === 'admin.easymarine.com.br') {
        apiHostname = 'api.easymarine.com.br';
        porta = '';
        easyWebPage = 'https://easymarine.com.br';
        easyWeb2Page = 'https://www2.easymarine.com.br';
        finServer = 'fin.easymarine.com.br';
        finContext = '/EasyFinanceiro/';
    }

    if (window.location.host === 'admin.refactor.easymarine.com.br') {
        // Ambiente de teste do refactor (regra 90 do easymarine-ecs-alb, mesmo TG do admin de producao): mesmo desenho
        // do ramo admin de producao, com a API do backend novo. Financeiro externo como no web2 de teste. Era a
        // sobreposicao de build (nao versionada) da imagem admin-00452eb9-refactor de 25/10/2026; versionada em 27/10/2026.
        apiHostname = 'api.refactor.easymarine.com.br';
        porta = '';
        easyWebPage = 'https://easymarine.com.br';
        easyWeb2Page = 'https://app.refactor.easymarine.com.br';
        finServer = 'fin.easymarine.com.br';
        finContext = '/EasyFinanceiro/';
    }

    if (window.location.host === 'aws-admin.easymarine.com.br') {
        apiHostname = 'aws-api.easymarine.com.br';
        porta = '';
        easyWebPage = 'https://easymarine.com.br';
        easyWeb2Page = 'https://easymarine.com.br';
        finServer = 'test.fin.easymarine.com.br';
    }

    if (window.location.hostname === 'adm.homolog.easymarine.com.br') {
        apiHostname = 'api.homolog.easymarine.com.br';
        porta = '';
        easyWebPage = 'http://test.site.easymarine.com.br';
        easyWeb2Page = 'https://homolog.easymarine.com.br';
    }

    const AppConfig = {
        brand: 'EasyMarine',
        user: 'Lisa',
        year,
        layoutBoxed: false,                             // true, false
        navCollapsed: storedNavCollapsed === null ? false : storedNavCollapsed, // EAS-249: persistido por usuário; default aberto
        navBehind: false,                               // true, false
        fixedHeader: true,                              // true, false
        sidebarWidth: 'middle',                         // small, middle, large
        theme: 'light',                                 // light, gray, dark
        colorOption: '34',                              // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
        AutoCloseMobileNav: true,                       // true, false. Automatically close sidenav on route change (Mobile only)
        productLink: 'https://themeforest.net/item/material-design-angular-2-admin-web-app-with-bootstrap-4/19421267',
        apiHost: window.location.protocol + '//' + apiHostname + porta,
        finApiIntegracao: window.location.protocol + '//' + finServer + finContext + 'integracao/api/financeiro/',
        finApi: window.location.protocol + '//' + finServer + finContext + 'api/financeiro/',
        admApi: 'https://api.adm.scc4.com.br',
        easyWebPage,
        easyWeb2Page
    };

    return AppConfig;
}

export const APPCONFIG = makeAppConfig();



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/config.ts